import React from "react";
import ReactECharts from "echarts-for-react";

const PieSpare = ({ data }) => {
    // Prepare chart data for Pie
    const pieData = Array.isArray(data)
        ? data.map((item) => ({
            name: item.key ?? "Unknown",
            value: item.doc_count ?? 0,
        }))
        : [];

    const option = {
        tooltip: {
            trigger: "item",
            formatter: "{b}: {c} ({d}%)",
        },
        legend: {
            orient: "vertical",
            left: "left",
            textStyle: { fontSize: 12 },
        },
        series: [
            {
                name: "Spare Parts",
                type: "pie",
                radius: ["20%", "40%"], // donut style
                avoidLabelOverlap: false,
                itemStyle: {
                    borderRadius: 4,
                    borderColor: "#fff",
                    borderWidth: 2,
                },
                label: {
                    show: true,
                    position: "outside",
                    formatter: "{b}: {d}%",
                    fontSize: 12,
                },
                labelLine: {
                    show: true,
                },
                data: pieData,
            },
        ],
        color: [
            "#5DADE2",
            "#F5B041",
            "#58D68D",
            "#AF7AC5",
            "#EC7063",
            "#F4D03F",
            "#48C9B0",
            "#CD6155",
            "#5499C7",
        ],
    };

    return (
        <div className="border rounded shadow-sm p-3 bg-white flex justify-center items-center">
            <ReactECharts
                option={option}
                style={{ height: "300px", width: "100%" }}
            />
        </div>
    );
};

export default PieSpare;
